import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { hasCollaborativePermissionsOnProject } from "~/store/selectors/selector.users.jsx";
import AddToTaskTrigger from "../AddToTaskTrigger.jsx";

const AddDependencyToTaskTrigger = ({ ...rest }) => {
  const { t } = useTranslation();

  const canModify = useSelector((state) => hasCollaborativePermissionsOnProject(state, rest.projectId));

  return canModify ? (
    <AddToTaskTrigger
      {...rest}
      labelText={t("Add a Dependency")}
      className="tw--ml-1 tw-my-0"
    />
  ) : null;
};

export default AddDependencyToTaskTrigger;
